import { useState } from 'react';

import { useFlags } from '@/services/auth';

import { EmailStep } from './steps/EmailStep';
import { MfaStep } from './steps/MfaStep';
import { PasswordStep } from './steps/PasswordStep';
import { LegacyLogin } from './LegacyLogin';

export const Login = () => {
  const { flags } = useFlags();

  const [step, setStep] = useState<'email' | 'password' | 'mfa'>('email');
  const [email, setEmail] = useState('');
  const [mfaToken, setMfaToken] = useState<string>();
  const [mfaExpired, setMfaExpired] = useState(false);

  if (!flags) {
    return null;
  }

  if (!flags?.['enable-sso-authentication']) {
    return <LegacyLogin />;
  }

  if (step === 'email') {
    return (
      <EmailStep
        onNext={(email) => {
          setStep('password');
          setEmail(email);
        }}
        mfaExpired={mfaExpired}
      />
    );
  }

  if (step === 'password') {
    return (
      <PasswordStep
        email={email}
        onPrevious={() => setStep('email')}
        onMfaRequired={(mfaToken) => {
          setStep('mfa');
          setMfaToken(mfaToken);
          setMfaExpired(false);
        }}
      />
    );
  }

  if (step === 'mfa') {
    return (
      <MfaStep
        mfaToken={mfaToken!}
        onMfaExpired={() => {
          setStep('email');
          setMfaExpired(true);
        }}
      />
    );
  }

  return null;
};
